// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.emailverification.RentalManagerUserEmailVerificationWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserEmailVerificationWebApiHandler_getUnverifiedEmailListings,
  RentalManagerUserEmailVerificationWebApiHandler_getUnverifiedEmailListings_Path,
  RentalManagerUserEmailVerificationWebApiHandler_sendSecurityToken,
  RentalManagerUserEmailVerificationWebApiHandler_sendVerificationCode,
  RentalManagerUserEmailVerificationWebApiHandler_validateVerificationCode,
  RentalManagerUserEmailVerificationWebApiHandler_verifySecurityToken,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  EmailVerificationType,
  ListingAlias,
  RentalManagerContactEmailVerificationCodeValidationDto,
  RentalManagerContactEmailVerificationEmailVerificationDto,
  RentalManagerVerificationEmailUnverifiedEmailListingsDto,
  UserEmailVerificationSendSecurityTokenResponseWebDto,
  UserEmailVerificationVerifySecurityTokenResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

interface GetUnverifiedEmailListingsParams {
  limit?: number;
}
interface SendSecurityTokenParams {
  email?: string;
  emailVerificationType?: EmailVerificationType;
  successRedirectPath?: string;
}
interface SendVerificationCodeParams {
  email: string;
  listingAlias: ListingAlias;
}
interface ValidateVerificationCodeParams {
  email: string;
  listingAlias: ListingAlias;
  verificationCode: string;
}
interface VerifySecurityTokenParams {
  securityToken: string;
}

export type RentalManagerUserEmailVerificationWebApiHandler_getUnverifiedEmailListings_Options = UseQueryOptions<
  RentalManagerVerificationEmailUnverifiedEmailListingsDto,
  unknown,
  RentalManagerVerificationEmailUnverifiedEmailListingsDto,
  readonly [string, GetUnverifiedEmailListingsParams]
>;

const RentalManagerUserEmailVerificationWebApiHandler_getUnverifiedEmailListings_GetKey = (
  getParams: GetUnverifiedEmailListingsParams,
) => [RentalManagerUserEmailVerificationWebApiHandler_getUnverifiedEmailListings_Path, getParams] as const;

export const RentalManagerUserEmailVerificationWebApiHandler_getUnverifiedEmailListings_queryOptions = (
  getParams: GetUnverifiedEmailListingsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserEmailVerificationWebApiHandler_getUnverifiedEmailListings_GetKey(getParams),
    queryFn: () => RentalManagerUserEmailVerificationWebApiHandler_getUnverifiedEmailListings(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get list of claimable listings if this user has an unverified email address
 */
export const useRentalManagerUserEmailVerificationWebApiHandler_getUnverifiedEmailListings = (
  getParams: GetUnverifiedEmailListingsParams,
  {
    httpClient,
    ...options
  }: Omit<
    RentalManagerUserEmailVerificationWebApiHandler_getUnverifiedEmailListings_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...RentalManagerUserEmailVerificationWebApiHandler_getUnverifiedEmailListings_queryOptions(getParams, {
      httpClient,
    }),
    ...options,
  });
};
useRentalManagerUserEmailVerificationWebApiHandler_getUnverifiedEmailListings.getKey =
  RentalManagerUserEmailVerificationWebApiHandler_getUnverifiedEmailListings_GetKey;

export interface RentalManagerUserEmailVerificationWebApiHandler_sendSecurityToken_Args {
  getParams: SendSecurityTokenParams;
}

export type RentalManagerUserEmailVerificationWebApiHandler_sendSecurityToken_Options = UseMutationOptions<
  UserEmailVerificationSendSecurityTokenResponseWebDto,
  unknown,
  RentalManagerUserEmailVerificationWebApiHandler_sendSecurityToken_Args
>;

/**
 * Email the email verification link to the user
 */
export const useRentalManagerUserEmailVerificationWebApiHandler_sendSecurityToken = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserEmailVerificationWebApiHandler_sendSecurityToken_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserEmailVerificationWebApiHandler_sendSecurityToken_Args) =>
      RentalManagerUserEmailVerificationWebApiHandler_sendSecurityToken(args.getParams, httpClient),
  });
};

export interface RentalManagerUserEmailVerificationWebApiHandler_sendVerificationCode_Args {
  getParams: SendVerificationCodeParams;
}

export type RentalManagerUserEmailVerificationWebApiHandler_sendVerificationCode_Options = UseMutationOptions<
  RentalManagerContactEmailVerificationEmailVerificationDto,
  unknown,
  RentalManagerUserEmailVerificationWebApiHandler_sendVerificationCode_Args
>;

/**
 * Email the contact email verification code to the user
 */
export const useRentalManagerUserEmailVerificationWebApiHandler_sendVerificationCode = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserEmailVerificationWebApiHandler_sendVerificationCode_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserEmailVerificationWebApiHandler_sendVerificationCode_Args) =>
      RentalManagerUserEmailVerificationWebApiHandler_sendVerificationCode(args.getParams, httpClient),
  });
};

export interface RentalManagerUserEmailVerificationWebApiHandler_validateVerificationCode_Args {
  getParams: ValidateVerificationCodeParams;
}

export type RentalManagerUserEmailVerificationWebApiHandler_validateVerificationCode_Options = UseMutationOptions<
  RentalManagerContactEmailVerificationCodeValidationDto,
  unknown,
  RentalManagerUserEmailVerificationWebApiHandler_validateVerificationCode_Args
>;

/**
 * Validate code for contact email verification
 */
export const useRentalManagerUserEmailVerificationWebApiHandler_validateVerificationCode = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserEmailVerificationWebApiHandler_validateVerificationCode_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserEmailVerificationWebApiHandler_validateVerificationCode_Args) =>
      RentalManagerUserEmailVerificationWebApiHandler_validateVerificationCode(args.getParams, httpClient),
  });
};

export interface RentalManagerUserEmailVerificationWebApiHandler_verifySecurityToken_Args {
  getParams: VerifySecurityTokenParams;
}

export type RentalManagerUserEmailVerificationWebApiHandler_verifySecurityToken_Options = UseMutationOptions<
  UserEmailVerificationVerifySecurityTokenResponseWebDto,
  unknown,
  RentalManagerUserEmailVerificationWebApiHandler_verifySecurityToken_Args
>;

/**
 * Verify securityToken from email verification
 */
export const useRentalManagerUserEmailVerificationWebApiHandler_verifySecurityToken = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserEmailVerificationWebApiHandler_verifySecurityToken_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserEmailVerificationWebApiHandler_verifySecurityToken_Args) =>
      RentalManagerUserEmailVerificationWebApiHandler_verifySecurityToken(args.getParams, httpClient),
  });
};
